"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SysSettingRoutes = void 0;
var SysSettingRoutes;
(function (SysSettingRoutes) {
    SysSettingRoutes["BasePrefix"] = "sys-settings";
    SysSettingRoutes["ById"] = ":sysSettingId";
    SysSettingRoutes["All"] = "all";
    SysSettingRoutes["Common"] = "common";
    SysSettingRoutes["CommonShell"] = "common-shell";
    SysSettingRoutes["List"] = "list";
})(SysSettingRoutes = exports.SysSettingRoutes || (exports.SysSettingRoutes = {}));
